import { Injectable } from '@angular/core';

import { Material } from "./material.model";
import { RestService } from "../../../../core/services/rest.service";
import { AuthService } from "../../../../shared/services/auth.service";
import {
    materiaisRouter, materialRouter, materialStorageName, materialApi,
    materialGrupoCodigoMask, materialCodigoMask
} from "./data.service";
import { detailRoute, newRoute, editRoute } from "../../../../shared/services/data.service";
import { almoxarifadoRoute } from "../../../shared/data.service";
import {ordensServicoItemsStorage} from "../../../../manutencoes/ordens-servico/shared/data.service";
import {OrdemServicoService} from "../../../../manutencoes/ordens-servico/shared/ordem-servico.service";
import {OrdemServicoNavigationService} from "../../../../manutencoes/ordens-servico/shared/ordem-servico-navigation.service";
import {AutoCompleteService} from "../../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class MaterialService {
    private apiUrl: string = materialApi;
    private storageName: string = materialStorageName;

    constructor(
        private _restService: RestService,
        private _authService: AuthService,
        private _ordemServicoService: OrdemServicoService,
        private _ordemServicoNavigationService: OrdemServicoNavigationService,
        private _autocompleteService: AutoCompleteService
    ){}

    onPost(object: Material, done: any) {
        this._restService.onPost(this.apiUrl, object, done);
    }

    onPut(object: Material, done: any) {
        this._restService.onPut(this.apiUrl, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(this.apiUrl, objectId, done);
    }

    onGetAll(done: any) {
        var filter: any = {"order":"descricao","include":[{"grupoMaterial":"grupo"},"tipo"]};
        this._restService.onGetPost(this.apiUrl, filter, done);
    }

    onGetById(objectId:number, done: any) {
        var filter: any = {"include":[{"grupoMaterial":["grupo","contaContabil"]},"medida","contaContabil","tipo"]};
        this._restService.onGetPostId(this.apiUrl, objectId, filter, done);
    }

    onGetApiUrl() {
        return this.apiUrl;
    }

    //storage
    setStorage(item: Material) {
        var object: string = JSON.stringify(item);
        localStorage.setItem(this.storageName + '-selected', object);
    }

    getStorage() {
        var item: string = localStorage.getItem(this.storageName + "-selected");
        return JSON.parse(item);
    }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(this.storageName + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(this.storageName + "-new");
        return JSON.parse(item);
    }

    clearStorage() {
        sessionStorage.clear();
        localStorage.clear();
    }

    //router
    goToList() {
        var router: string =  almoxarifadoRoute + '/' + materiaisRouter + '/' + materialRouter;
        this._authService.navigateTo(router);
    }

    goToAdd() {
        var router: string = almoxarifadoRoute + '/' + materiaisRouter + '/' + materialRouter + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        var router: string = almoxarifadoRoute + '/' + materiaisRouter + '/' + materialRouter + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

    goToDetail(objectId: number) {
        var router: string = almoxarifadoRoute + '/' + materiaisRouter + '/' + materialRouter + '/' + detailRoute;
        this._authService.navigateTo(router, objectId);
    }

    //others
    getClassificacao(materialObject: any) {
        var materialType: any = materialObject.tipo,
            materialGrupoCodigo: any = materialObject.grupo,
            materialSubgrupoCodigo: any = materialObject.subgrupo,
            materialCodigo: any = materialObject.id,
            classificacao: string = '',
            x: any, lenX: any, codigoLength: any;

        if (materialType.id) {
            materialType = materialType.id;
        }

        if (materialGrupoCodigo) {
            materialGrupoCodigo = materialGrupoCodigo.codigo;

            if (typeof materialGrupoCodigo !== 'string') {
                materialGrupoCodigo = materialGrupoCodigo.toString();
            }
            codigoLength = materialGrupoCodigo.length;

            for (x = codigoLength, lenX = materialGrupoCodigoMask; x < lenX; x++) {
                materialGrupoCodigo = "0" + materialGrupoCodigo;
            }
        }

        if (materialSubgrupoCodigo) {
            materialSubgrupoCodigo = materialSubgrupoCodigo.codigoGrupo;

            if (typeof materialSubgrupoCodigo !== 'string') {
                materialSubgrupoCodigo = materialSubgrupoCodigo.toString();
            }
            codigoLength = materialSubgrupoCodigo.length;

            for (x = codigoLength, lenX = materialGrupoCodigoMask; x < lenX; x++) {
                materialSubgrupoCodigo = "0" + materialSubgrupoCodigo;
            }
        }

        if (materialCodigo) {
            if (typeof materialCodigo !== 'string') {
                materialCodigo = materialCodigo.toString();
            }
            codigoLength = materialCodigo.length;

            for (x = codigoLength, lenX = materialCodigoMask; x < lenX; x++) {
                materialCodigo = "0" + materialCodigo;
            }
        }

        classificacao = materialGrupoCodigo + '.' + materialSubgrupoCodigo + '.' + materialCodigo + "-" +  materialType;
        return classificacao;
    }

    //qndo retorna para continuar o cadastro, caso tenha ido para outro formulario
    returnToForm() {
        var session: any = this.getSessionStorage();
        if (session && session.id) {
            this.goToEdit(session.id);
        } else {
            this.goToAdd();
        }
    }

    returnToOtherForm(otherForm: string, Response: any) {
        let otherFormObject: any;
        if(Response) {
            if (otherForm === ordensServicoItemsStorage) {
                otherFormObject = this._ordemServicoService.getItemsSessionStorage();
                otherFormObject.material = Response;
                otherFormObject.medidaId = Response.medidaId;
                this._ordemServicoService.setItemsSessionStorage(otherFormObject);
            }
        }

        this._autocompleteService.clearSessionStorage(materialStorageName);

       if (otherForm === ordensServicoItemsStorage) {
            otherFormObject = this._ordemServicoService.getItemsSessionStorage();
            if (otherFormObject.id) {
                this._ordemServicoNavigationService.goToEditServico(otherFormObject.osId, otherFormObject.tipo, otherFormObject.id);
            } else {
                this._ordemServicoNavigationService.goToNewServico(otherFormObject.osId, otherFormObject.tipo);
            }
        }
    }

    templateResult = (function(state: any, isCreateNew: boolean) {
        var stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    let name: string = state.descricao;
                    text = name;
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/shared/material.service.ts
 **/